const MODULE = 'fulcrum/containers/Form/HorizontalTable/'
const HORIZONTAL_TABLE_ADD = MODULE + 'HORIZONTAL_TABLE_ADD'
const HORIZONTAL_TABLE_REMOVE = MODULE + 'HORIZONTAL_TABLE_REMOVE'
const HORIZONTAL_TABLE_UPDATE = MODULE + 'HORIZONTAL_TABLE_UPDATE'
const HORIZONTAL_TABLE_NESTED_ADD = MODULE + 'HORIZONTAL_TABLE_NESTED_ADD'
const HORIZONTAL_TABLE_NESTED_REMOVE = MODULE + 'HORIZONTAL_TABLE_NESTED_REMOVE'
const HORIZONTAL_TABLE_NESTED_UPDATE = MODULE + 'HORIZONTAL_TABLE_NESTED_UPDATE'

export {
    HORIZONTAL_TABLE_ADD,
    HORIZONTAL_TABLE_REMOVE,
    HORIZONTAL_TABLE_UPDATE,
    HORIZONTAL_TABLE_NESTED_ADD,
    HORIZONTAL_TABLE_NESTED_REMOVE,
    HORIZONTAL_TABLE_NESTED_UPDATE,
}